<template>
  <div class="UsersViewHint">
    <div class="content">
      <div class="content__header">
        Z łatwością zarządzaj swoim zespołem
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Dodaj użytkownika
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Nadaj uprawnienia
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            3
          </div>
        </div>
        <label>
          Usuń lub aktywuj użytkownika
        </label>
      </div>
      <div class="content__footer">
        Pamiętaj, aby dane do logowania przekazać
        w bezpieczny sposób.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UsersViewHint',


};
</script>
